import { Component } from '@angular/core';
import { AuthService } from 'src/services';
import { NavigationService } from 'src/services/navigation.service';

@Component({
  selector: 'app-market-benchmarks',
  templateUrl: './market-benchmarks.component.html',
  styleUrl: './market-benchmarks.component.scss'
})
export class MarketBenchmarksComponent 
{
   constructor(private navigationService: NavigationService, private authService: AuthService) { }
  printPage() {
    window.print();
  }

  copyFullPageText() {
    // Get all text from the body of the document
    const textToCopy = document.body.innerText;

    navigator.clipboard.writeText(textToCopy).then(() => {
      this.authService.showToast("info","All text on the page has been copied!");
    }).catch(err => {
      console.error("Failed to copy text: ", err);
    });
  }

}
